type Reserve = { id: string; reserve: string; gravite: string };

/** Bloc obligatoire : ce que le commercial ne doit pas affirmer. */
export function BlocReserves({ reserves }: { reserves: Reserve[] }) {
  if (reserves.length === 0) {
    return (
      <div className="panel reserve-manquante">
        <p><strong>Aucune réserve enregistrée.</strong></p>
        <p>La fiche n'est pas validée : générer l'argumentaire avant d'appeler.</p>
      </div>
    );
  }
  return (
    <section className="panel">
      <h2 className="blocktitle">Réserves — ne pas affirmer</h2>
      {reserves.map(r => (
        <p key={r.id} className={`reserve ${r.gravite}`}>
          <span className="g">{r.gravite}</span> {r.reserve}
        </p>
      ))}
    </section>
  );
}
